export default __webpack_public_path__ + "static/media/ColabLogo.1634163f.png";